import React from 'react';
// import Row from '../../../core/layout/Row';
// import Column from '../../../core/layout/Column';
// import { get } from 'lodash';
// import MonthInput from '../../../core/form/MonthInput';
import PropTypes from 'prop-types';
import Card from '../../../core/layout/Card';
import Separator from '../../../core/layout/Separator';
import FormButtons from '../../../core/form/FormButtons';
import DowngradeContractProductsListContainer from './DowngradeContractProductsListContainer';
import Button from '../../../core/form/Button';

const DowngradeContractForm = (props) => {
  return (
    <form
      onSubmit={(event) => {
        event.preventDefault();
        props.onSubmit();
      }}
    >
      <Card loading={props.loading} title="Downgrade info">
        <p>The downgrade will begin in the next cycle.</p>
        {/*<Row>*/}
        {/*  <Column size={3}>*/}
        {/*    <MonthInput*/}
        {/*      disabled={props.submitting}*/}
        {/*      label="Downgrade starts in"*/}
        {/*      value={get(props.values, 'startsAt', null)}*/}
        {/*      onChange={(value) => props.onChange('startsAt', value)}*/}
        {/*      errorText={get(props.errors, 'startsAt', '')}*/}
        {/*    />*/}
        {/*  </Column>*/}
        {/*  <Column size={3}>*/}
        {/*    <MonthInput*/}
        {/*      disabled={props.submitting || props.loading}*/}
        {/*      label="Downgrade ends in"*/}
        {/*      value={get(props.values, 'endsAt', null)}*/}
        {/*      onChange={(value) => props.onChange('endsAt', value)}*/}
        {/*    />*/}
        {/*  </Column>*/}
        {/*</Row>*/}
      </Card>
      <Separator />
      <Card
        title="Downgrade Products"
        actions={
          <Button
            label="Add Product"
            onClick={props.onAddProduct}
            disabled={props.submitting || props.loading || props.disabled}
          />
        }
      >
        <DowngradeContractProductsListContainer />
      </Card>
      <Separator />
      <FormButtons
        confirmLabel="Downgrade Contract"
        isDisabled={props.submitting || props.loading || props.disabled}
        isSubmitting={props.submitting}
        onReset={props.onReset}
      />
    </form>
  );
};

DowngradeContractForm.propTypes = {
  onChange: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  values: PropTypes.object,
  disabled: PropTypes.bool,
  errors: PropTypes.object,
  submitting: PropTypes.bool,
  loading: PropTypes.bool,
  contractType: PropTypes.string,
  onAddProduct: PropTypes.func.isRequired,
};
DowngradeContractForm.defaultProps = {
  values: {},
  errors: {},
  submitting: false,
  loading: false,
};

export default DowngradeContractForm;
